'use client';

import { c as _c } from "react/compiler-runtime";
import type { TableSort } from '@/features/hof-dashboard/hooks/use-table-sort';
import { cn } from '@/utils/tailwindcss-override';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type React from 'react';

/**
 * A column head that sorts its table: the whole label is the button, the arrow shows the
 * direction, and a column that could sort shows a faint double arrow. `aria-sort` tells a
 * screen reader which column the table is sorted by.
 */
export const SortableHeader = t0 => {
  const $ = _c(26);
  const {
    sortKey,
    sort,
    onSort,
    align: t1,
    className,
    children
  } = t0;
  const align = t1 === undefined ? "left" : t1;
  const active = sort?.key === sortKey;
  let Icon = ArrowUpDown;
  if (active) {
    Icon = sort.direction === "ascending" ? ArrowUp : ArrowDown;
  }
  const t2 = active ? sort.direction : undefined;
  let t3;
  if ($[0] !== className) {
    t3 = cn("px-0 py-0 align-bottom", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = align === "right" ? "justify-end text-right" : "justify-start text-left";
  let t5;
  if ($[2] !== t4) {
    t5 = cn("group flex min-h-11 w-full cursor-pointer items-end gap-1 px-3 py-3 [letter-spacing:inherit] [text-transform:inherit] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-green-600 @min-[900px]/dashboard:pointer-fine:min-h-[32px] @min-[900px]/dashboard:pointer-fine:py-[8px]", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== onSort || $[5] !== sortKey) {
    t6 = () => onSort(sortKey);
    $[4] = onSort;
    $[5] = sortKey;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = align === "right" && "order-last";
  let t8;
  if ($[7] !== t7) {
    t8 = cn(t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== children || $[10] !== t8) {
    t9 = <span className={t8}>{children}</span>;
    $[9] = children;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const T0 = Icon;
  const t10 = active ? "text-green-900" : "text-gray-300 group-hover:text-green-600";
  let t11;
  if ($[12] !== t10) {
    t11 = cn("mb-px h-3.5 w-3.5 shrink-0", t10);
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== Icon || $[15] !== t11) {
    t12 = <T0 aria-hidden={true} className={t11} />;
    $[14] = Icon;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t5 || $[19] !== t6 || $[20] !== t9) {
    t13 = <button type="button" className={t5} onClick={t6}>{t9}{t12}</button>;
    $[17] = t12;
    $[18] = t5;
    $[19] = t6;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t2 || $[24] !== t3) {
    t14 = <th scope="col" aria-sort={t2} className={t3}>{t13}</th>;
    $[22] = t13;
    $[23] = t2;
    $[24] = t3;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};